import React from 'react';
import "./PageBreak.css"

const PageBreak = (props) => (
    <div className={"pagebreak"} />
);


export default PageBreak;


// WEBPACK FOOTER //
// ./src/common/components/PrintReport/PageBreak.js